import React from 'react';

const VisionMissionComponent = () => {
  return (
    <div className="max-w-6xl mx-auto p-4 md:p-6 text-left">
      <div className="space-y-8">
        {/* Vision Section */}
        <div className="flex flex-col md:flex-row items-center md:items-center md:space-x-6 space-y-4 md:space-y-0">
          <div className="relative">
            <div className="w-28 h-28 md:w-48 md:h-48 bg-yellow-400 rounded-full flex items-center justify-center">
              {/* Multiple border elements with different rotations */}
              <div className="absolute inset-0 rounded-full border-2 border-purple-900 translate-y-2 -translate-x-1"></div>
              <span className="text-xl md:text-3xl font-bold text-purple-900">VISION</span>
            </div>
          </div>
          <div className="pt-0 md:pt-3 text-center md:text-left">
            <h2 className="text-xl md:text-4xl font-arial-rounded text-primary font-bold">
              A world where everyone can live freely and reach their full potential—no matter their ability.
            </h2>
          </div>
        </div>
        {/* Mission Section */}
        <div className="flex flex-col md:flex-row items-center md:items-center md:space-x-6 space-y-4 md:space-y-0">
          <div className="relative">
            <div className="w-28 h-28 md:w-48 md:h-48 bg-yellow-400 rounded-full flex items-center justify-center">
              {/* Multiple border elements with different rotations */}
              <div className="absolute inset-0 rounded-full border-2 border-purple-900 translate-y-2 -translate-x-1"></div>
              <span className="text-xl md:text-3xl font-bold text-purple-900">MISSION</span>
            </div>
          </div>
          <div className="pt-0 md:pt-3 text-center md:text-left">
            <p className="md:text-lg">
              To build diversity, collaboration, and community inclusion within and beyond our community.
            </p>
          </div>
        </div>
        {/* Why Us Section */}
        <div className="flex flex-col md:flex-row items-center md:items-center md:space-x-6 space-y-4 md:space-y-0">
          <div className="relative">
            <div className="w-28 h-28 md:w-48 md:h-48 bg-yellow-400 rounded-full flex items-center justify-center">
              {/* Multiple border elements with different rotations */}
              <div className="absolute inset-0 rounded-full border-2 border-purple-900 translate-y-2 -translate-x-1"></div>
              <span className="text-xl md:text-3xl font-bold text-purple-900">WHY US?</span>
            </div>
          </div>
          <div className="pt-0 md:pt-3 text-center md:text-left">
            <p className="md:text-lg">
              At Livability Care Australia, we firmly believe that you can make a house feel like a home.
              Our team of specialists will work with you to develop the right care plan and find the right
              home to meet your needs and likes. We will also go the extra mile to find and match your
              housemates based on your preferences, personality, and care needs.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VisionMissionComponent;